// extracted by mini-css-extract-plugin
export default {"iconContainer":"UsersCounter_iconContainer__dPu63","counter":"UsersCounter_counter__jerA8"};